import React, { useContext, useState } from "react";
import { useMutation } from "@tanstack/react-query";

//Common
import { Snackbar } from "../../../common/VFX-UI";

//App
import { LookupTypeViewModel } from "../../../../viewModels";
import { LookupTypeDto } from "../../../../app/model/api/types/dto";
import lookupTypeApi from "../../../../app/model/api/lookupTypeApi";
import LookupTypeForm from "./LookupTypeForm";
import { LookupTypeContext } from "./LookupTypeContainer";
import { EMPTY_GUID } from "../../../../utility/constants";
import { apiErrorMessage } from "../../../../utility/lib/error";
import { LookupTypeFormContainerProps } from "../../../../types/lookupType";
import { SnackbarState } from "../../../../types";

const LookupTypeFormContainer: React.FC<LookupTypeFormContainerProps> = (
  props
) => {
  const { onClose, onShowSuccess } = props;
  const lookupTypeContext = useContext(LookupTypeContext);

  const [snackbar, setSnackbar] = useState<SnackbarState>({
    showErrorSnackbar: false,
    errorMessage: "",
  });

  const successMessage = lookupTypeContext?.id
    ? "Lookup Type updated"
    : "New Lookup Type added";

  const onShowErrorSnackbar = (errorMessage: string) =>
    setSnackbar({
      showErrorSnackbar: true,
      errorMessage,
    });

  const onCloseSnackbar = () =>
    setSnackbar({
      showErrorSnackbar: false,
      errorMessage: "",
    });

  const { status, mutate } = useMutation<void, Error, LookupTypeDto>({
    mutationFn: async (payload: LookupTypeDto) => {
      const response = await lookupTypeApi.save(payload);
      const errorMessage = apiErrorMessage(response.errorMessages);
      if (errorMessage) {
        onShowErrorSnackbar(errorMessage);
      } else {
        onShowSuccess(successMessage);
      }
    },
  });

  const handleSubmit = async (values: LookupTypeViewModel) => {
    const lookupType: LookupTypeDto = values.toDto();
    mutate(lookupType);
  };

  const initialValues = lookupTypeContext?.id
    ? new LookupTypeViewModel(
        lookupTypeContext?.data?.id ?? null,
        lookupTypeContext?.data?.name ?? null,
        lookupTypeContext?.data?.description ?? null,
        lookupTypeContext?.data?.sortValue ?? null,
        lookupTypeContext?.data?.isActive ?? null,
        lookupTypeContext?.data?.isGrouped ?? null
      )
    : new LookupTypeViewModel(EMPTY_GUID, "", "", 100, true, false);

  return (
    <>
      <LookupTypeForm
        initialVal={initialValues}
        status={status}
        handleOnSubmit={handleSubmit}
        onClose={onClose}
      />
      {snackbar.showErrorSnackbar && (
        <Snackbar
          open={true}
          message={snackbar.errorMessage}
          handleClose={onCloseSnackbar}
          severity="danger"
        />
      )}
    </>
  );
};

export default LookupTypeFormContainer;
